export default "__VITE_ASSET__4mGRAZaG__"